import React from 'react'
import { Content } from './Content'
import { Header } from './Header'

export const InfantView = (): JSX.Element => {
  return (
    <>
      <Header />
      <Content />
    </>
  )
}
